import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { TypeVoie } from '../models/TypeVoie';

@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() voie: TypeVoie;
  @Input() rule = '';
  @Input() errorMessage = '';

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_TypeVoie';
  }
}
